/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC, ReactElement } from 'react'
import Input, { InputProps } from '../input'

type DecimalProps = {
  value?: number | string
  prefix?: string
}

function toNumeric (prefix = '', value?: string | number): number {
  const result = String('000' + (value || '')).replace(prefix, '').replace(/[.,]/g, '')
  return Number(result.replace(/\b(\d+)(\d{2})\b/, '$1.$2'))
}

function moveCursorToEnd (e: any): void {
  const el = e.target
  try {
    if (typeof el.selectionStart === 'number') {
      el.selectionStart = el.selectionEnd = el.value.length
    } else if (typeof el.createTextRange !== 'undefined') {
      el.focus()
      const range = el.createTextRange()
      range.collapse(false)
      range.select()
    }
  } catch (err) {}
}

function handleValue (prefix = '', value?: number | string): string {
  return (prefix || '') + Number(value || 0).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

const Decimal: FC<InputProps & DecimalProps> = ({ value, prefix, onChange, onFocus, ...restProps }): ReactElement => {
  return (
    <Input
      {...restProps}
      type='tel'
      value={handleValue(prefix, value)}
      onClick={(e: any) => {
        e.target.select()
      }}
      onChange={(e: any) => {
        if (onChange) onChange({ target: { value: toNumeric(prefix, e.target.value) } })
        setTimeout(() => moveCursorToEnd(e))
      }}
      onFocus={e => {
        moveCursorToEnd(e)
        if (onFocus) onFocus(e)
      }}
    />
  )
}

export default Decimal
